<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true" :isHdRightAttached="true">
    <template v-slot>
      <div class="dialog type-non-footer">
        <header class="dialog-header">
          <h2 class="dialog-title only-pc">
            알림(<span class="system">{{
              data.alimCount
            }}</span
            >)
              <button type="button" 
                      class="c-flag type-green type-small type-round"
                      @click="btnCmd('alimReadAll' , { tabName: 'all',list: data?.biz1?.list})">
                <span class="text">전체확인</span>
              </button>
          </h2>
          <button type="button" class="dialog-close" @click="btnCmd('close')">
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <!-- D: MO에서만 존재 -->
            <h3 class="c-title-level3 only-mo">
              알림(<span class="system">{{
                data.alimCount
            }}</span
              >)
              <button type="button" class="c-flag type-green type-small type-round"
                      @click="btnCmd('alimReadAll' , { tabName: 'all' })">
                <span class="text">전체확인</span>
              </button>
            </h3>
            <!-- // D: MO에서만 존재 -->
            <!-- D: KAKAO 주소검색 API 아래 div.adress-api-wrap 안에 넣어주세요. -->
            <div class="alarm-wrap">
              <!-- D: 알림분류 -->
              <div class="c-btn-area type-mo-scroll">
                <!-- D: 활성화클래스 is-active 추가 -->
                <button
                  type="button"
                  :class="[
                    'c-util-button type-line-gray type-small type-round',
                    {
                      'is-active': data.tab1name === 'all',
                    },
                  ]"
                  @click="btnCmd('tab1name', { tabName: 'all' })"
                >
                  <span class="bold">전체</span>
                </button>
                <button
                  type="button"
                  :class="[
                    'c-util-button type-line-gray type-small type-round',
                    {
                      'is-active': data.tab1name === 'ORDER',
                    },
                  ]"
                  @click="btnCmd('tab1name', { tabName: 'ORDER' })"
                >
                  <span class="bold">제품주문</span>
                </button>
                <button
                  type="button"
                  :class="[
                    'c-util-button type-line-gray type-small type-round',
                    {
                      'is-active': data.tab1name === 'COMBN',
                    },
                  ]"
                  @click="btnCmd('tab1name', { tabName: 'COMBN' })"
                >
                  <span class="bold">조색배합</span>
                </button>
                <button
                  type="button"
                  :class="[
                    'c-util-button type-line-gray type-small type-round',
                    {
                      'is-active': data.tab1name === '11REQ',
                    },
                  ]"
                  @click="btnCmd('tab1name', { tabName: '11REQ' })"
                >
                  <span class="bold">1:1문의</span>
                </button>
                <button
                  type="button"
                  :class="[
                    'c-util-button type-line-gray type-small type-round',
                    {
                      'is-active': data.tab1name === 'NTC',
                    },
                  ]"
                  @click="btnCmd('tab1name', { tabName: 'NTC' })"
                >
                  <span class="bold">공지사항</span>
                </button>
              </div>
              <!-- // D: 알림분류 -->
              <!-- D: 알림 리스트 -->
              <div
                class="alarm-list-wrap"
                v-if="data?.biz1?.list && data?.biz1?.list.length > 0"
              >
                <div
                  v-for="(item1, index1) in filteredList1(data.tab1name)"
                  :key="index1"
                  class="alarm-item"
                >
                  <h3 class="title">
                    {{ item1.regDtInfo }}
                  </h3>
                  <div class="content-box">
                    <ul>
                      <li
                        v-for="(item2, index2) in filteredList2(
                          data.tab1name,
                          item1.regDtInfo
                        )"
                        :key="index2"
                      >
                        <span class="c-flag type-board type-gray">{{
                          item2.alarmTaskGrpCdNm
                        }}</span>
                        <!-- D: 방문한 사이트 색상변하게 css 처리(개발시 javascript:(0); 수정후 개발해주세요.) -->
                        <a
                          @click="btnCmd('alimRead', item2)"
                          :class="{
                            'is-visited':
                              item2.pstInqYn == 'Y' ||
                              item2.rcptnIdntyYn == 'Y',
                          }"
                        >
                          <template v-if="item2.alarmTaskGrpCd == 'NTC'">
                            <span
                              class="subject"
                              v-html="
                                item2.alarmTaskSeCdNm +
                                '<br/>' +
                                sanitizeHTML(item2.alarmTitleNm)
                              "
                            ></span>
                          </template>
                          <template v-else>
                            <span
                              class="subject"
                              v-html="sanitizeHTML(item2.alarmTitleNm)"
                            ></span>
                            <strong
                              class="summary"
                              v-html="sanitizeHTML(item2.alarmCn)"
                            />
                          </template>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- D: 알림 데이터없음 -->
                <div
                  class="c-no-data-box"
                  v-if="filteredList1(data.tab1name).length < 1"
                >
                  <div class="icon-box">
                    <i class="c-icon icon-nodata size-large"></i>
                  </div>
                  <p class="text">수신된 알림이 없습니다.</p>
                </div>
                <!-- // D: 알림 데이터없음 -->
              </div>
              <!-- // D: 알림 리스트 -->
              <!-- D: 알림 데이터없음 -->
              <div class="c-no-data-box" v-if="data.biz1?.list.length < 1">
                <div v-if="data.page.isPageInit" class="icon-box">
                  <i class="c-icon icon-nodata size-large"></i>
                </div>
                <p v-if="data.page.isPageInit" class="text">
                  수신된 알림이 없습니다.
                </p>
              </div>
              <!-- // D: 알림 데이터없음 -->
            </div>
            <!-- // D: KAKAO 주소검색 API 아래 div.adress-api-wrap 안에 넣어주세요. -->
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup>
import { onMounted,reactive, defineEmits } from "vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import * as store from "@/store";
import { useRouter } from "vue-router";

const router = useRouter();

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    isPageInit: false,
    token: "",
    isLogin: false,
    userLoginInfo: {},
    basketCount: {},
    breadcrumbItems: [
      { name: "zsample", path: "/paintpro/zsample" },
      { name: "zsample07", path: "/paintpro/zsample/zsample07" },
    ],
  },
  tab1name: 0,
  alimCount : 0,
  codes: {},
  popup: {},
  biz1: {
    list: [], // 목록
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
  data.alimCount = store.useAlimCountStore().alimCount;
  cmUtil.removeClassPopupOpen();
});


// const emits = defineEmits(["selectChanged"]);
const emits = defineEmits(["close"]);

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  cmUtil.loading("", { duration: 60000 });
  await pageInitData();
  data.tab1name = "all";
  searchCmd("biz1#search"); // biz1 데이타 조회
  cmUtil.loadingHide();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  const res = await cmApi.getPageInitData();
  const { resultCode } = res;
  if (resultCode !== 200) {
    return false;
  }
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#search") {
    data.biz1.loading = true;
    const res = await cmApi.selectUserAlimList();
    data.biz1.list = res.data;
    data.page.isPageInit = true;
  } else {
    alert(`[개발확인] searchCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

// 일자별 그룹명
function filteredList1(_grp1Nm = "") {
  let uniqItems = [];
  //const groupList =
  data.biz1.list.reduce((acc, item) => {
    const { alarmTaskGrpCd, regDtInfo } = item; // 그룹화 기준을 category로 설정
    if (["all", alarmTaskGrpCd].includes(_grp1Nm)) {
      const _groupName = _grp1Nm + "#" + regDtInfo; // 그룹기준
      if (!acc[_groupName]) {
        acc[_groupName] = []; // 그룹화된 객체가 없으면 새로 생성
        uniqItems.push(item);
      }
      acc[_groupName].push(item); // 해당 카테고리에 항목 추가
    }
    return acc;
  }, {});
  //return groupList;
  return uniqItems;
}

// // 그룹의 하위
function filteredList2(_grp1Nm = "", _grp2Nm = "") {
  let list = data.biz1.list.filter((item) => {
    const { alarmTaskGrpCd, regDtInfo } = item;
    return ["all", alarmTaskGrpCd].includes(_grp1Nm) && regDtInfo === _grp2Nm;
  });
  return list;
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  //alert("......." + JSON.stringify(parms, "", ""));
  if (cmd === "close") {
    emits("close");
  } else if (cmd === "tab1name") {
    data.tab1name = parms.tabName;
  } else if (cmd === "alimRead") {
    const res = cmApi.updateUserAlimRead({
      alarmCnSn: parms.alarmCnSn,
      alarmTaskSn: parms.alarmTaskSn,
      alarmTaskSeCd: parms.alarmTaskSeCd,
      alarmTaskGrpCd: parms.alarmTaskGrpCd,
    });
    const { resultCode } = res;
    if (resultCode !== 200) {
      // return false;
    }
    parms.pstInqYn = "Y"; // 게시물확인여부
    parms.rcptnIdntyYn = "Y"; // 수신확인여부부

    // 알림목록 > 제품주문 (가용재고)
    if (["ORDER", "KWMENG"].includes(parms.alarmTaskSeCd)) {
      router.push({
        path: "/paintpro/orderList/detail/" + (parms.alarmTaskSn || "0"),
      });
    } // 알림목록 > 조색배합
    else if (parms.alarmTaskSeCd === "COMBN") {
      router.push({
        path: "/paintpro/colorCombinList/" + (parms.alarmTaskSn || "0"),
      });
      //router.push({
      //  path: "/paintpro/colorCombinList",
      //});
    } // 알림목록 > 조색배합 (업데이트)
    else if (parms.alarmTaskSeCd === "UPDATE") {
      router.push({
        path:
          "/paintpro/colorCombinList/updateList/" + (parms.alarmTaskSn || "0"),
      });
      //router.push({
      //  path: "/paintpro/colorCombinList/updateList",
      //});
    } // 알림목록 > 1:1문의
    else if (parms.alarmTaskSeCd === "11REQ") {
      router.push({
        path: "/paintpro/utility/inquireList/" + (parms.alarmTaskSn || "0"),
      });
      //router.push({
      //  path: "/paintpro/utility/inquireList",
      //});
    } // 공지사항
    else if (parms.alarmTaskGrpCd === "NTC") {
      router.push({
        path:
          "/paintpro/custCenterList/noticeList/" + (parms.alarmTaskSn || "0"),
      });
    } else {
      alert(
        "[개발알림] alarmTaskSeCd 정보를 확인해주세요 : " + parms.alarmTaskSeCd
      );
    }
  } else if (cmd === "alimReadAll") {


    if (!(await cmUtil.confirm("모두 읽음 처리 하시겠습니까?"))) {
      return false;
    }else{
      let paramList = parms.list;

      const params = {
        api: {
          SD_ITEM: { item: paramList.filter((item) => !(item.pstInqYn === "Y" || item.rcptnIdntyYn === "Y") ) },
        }
      };
      const res = cmApi.updateUserAlimAllRead({params});

      if (res !== 200) {
        // return false;
        pageInit(); // 페이지 초기화 호출
        data.alimCount = 0;
        cmUtil.removeClassPopupOpen();
      }
    }
  }
}

// script 태그와 이벤트 핸들러 제거
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}
</script>
<style scoped></style>
